function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.17778 10.5464L9.6064 4.81931C9.84708 4.51047 9.93266 4.15341 9.85243 3.78985C9.7829 3.45934 9.57966 3.14508 9.27479 2.90668L8.53133 2.3161C7.88416 1.80137 7.08187 1.85555 6.62189 2.44613L6.12448 3.09144C6.06029 3.17217 6.07634 3.29137 6.15657 3.35639C6.15657 3.35639 7.41348 4.36418 7.44023 4.38585C7.5258 4.46713 7.58999 4.57549 7.60603 4.70553C7.63277 4.96018 7.45627 5.19858 7.19419 5.23109C7.07117 5.24735 6.95351 5.20942 6.86793 5.13898L5.54683 4.08785C5.48265 4.03963 5.38637 4.04992 5.33289 4.11494L2.19327 8.1786C1.99003 8.43326 1.92049 8.76377 1.99003 9.08344L2.39117 10.8227C2.41256 10.9148 2.49279 10.9798 2.58907 10.9798L4.3541 10.9581C4.67501 10.9527 4.97453 10.8064 5.17778 10.5464ZM7.64919 10.0047H10.5273C10.8081 10.0047 11.0364 10.2361 11.0364 10.5205C11.0364 10.8055 10.8081 11.0363 10.5273 11.0363H7.64919C7.36839 11.0363 7.14001 10.8055 7.14001 10.5205C7.14001 10.2361 7.36839 10.0047 7.64919 10.0047Z",
  fill: "#C7C9CC"
});
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.6481dd9f.svg";
export { ForwardRef as ReactComponent };